angular.module('blc').directive('menuOnside', dir);
function dir() {
  return function($scope, $element) {
    $element.append($('header .mainNav').clone()) 
  }
}



/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/menu-directive.js
 ** module id = 31
 ** module chunks = 0
 **/